export default __webpack_public_path__ + "static/media/jasperactive-QB-logo.2fb64be4.svg";